<template>
  <div>
    <!-- <AppLoader v-if="isLoading" class="text-center" small /> -->
    <b-overlay :show="isLoading" rounded="sm">
      <b-container fluid>
        <b-navbar toggleable="lg" type="dark" variant="light">
          <b-navbar-brand href="#" class="text-dark">
            <strong>Google Custom Search Engine Url</strong>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="showModal = !showModal"
                  class="mx-2"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>

                <b-button variant="outline-info" size="sm" @click="reloadTable">
                  <font-awesome-icon icon="sync" />
                </b-button>
                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <b-table
          class="mx-1"
          bordered
          sticky-header="calc(100vh - 200px)"
          ref="table"
          id="my-table"
          :busy.sync="isLoading"
          :items="getGoogleCustomSearchEngineUrlTableData"
          :fields="tableFields"
          :filter="filter"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        >
          <template v-slot:cell(type)="data">{{ data.item.type == 1 ? 'Local' : 'Global' }}</template>
          <template v-slot:cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                size="sm"
                class="mr-2"
                type="button"
                variant="outline-info"
                @click="onEditGoogleCustomSearchEngineUrl(data)"
              >
                <font-awesome-icon v-b-tooltip.hover title="Edit Field" icon="edit" />
              </b-button>
              <b-button
                size="sm"
                type="button"
                variant="outline-danger"
                @click="onDeleteGoogleCustomSearchEngineUrlModal(data)"
              >
                <font-awesome-icon v-b-tooltip.hover title="Delete Field" icon="trash" />
              </b-button>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col cols="2">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      size="lg"
      :title="editGoogleCustomSearchEngineUrl ? 'Update Google Custom Search Engine Url' : 'Create Google Custom Search Engine Url'"
      v-model="showModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label>
                  Url :
                  <span class="required-span">*</span>
                </label>
                <b-form-input
                  v-model="$v.form.url.$model"
                  :state="$v.form.url.$dirty ? !$v.form.url.$error : null"
                  placeholder="Enter Url"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label>
                  Url Type :
                  <span class="required-span">*</span>
                </label>
                <b-form-radio-group
                  v-model="$v.form.type.$model"
                  :state="$v.form.type.$dirty ? !$v.form.type.$error : null"
                  :options="typeOptions"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Select Google Custom Search Engine:">
                <b-form-checkbox-group
                  v-model="$v.form.selectedgoogleCustomSearchEngine.$model"
                  :state="$v.form.selectedgoogleCustomSearchEngine.$dirty ? !$v.form.selectedgoogleCustomSearchEngine.$error : null"
                  :options="googleCustomSearchEngineOptions"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{editGoogleCustomSearchEngineUrl ? 'Your Google Custom Search Engine Url is being Updating......' : 'Your Google Custom Search Engine is being Creating......'}}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ editGoogleCustomSearchEngineUrl ? 'Your Google Custom Search Engine Url has been updated successfully.' : 'Your Google Custom Search Engine has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" variant="outline-danger" @click="resetModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation()"
        >{{ editGoogleCustomSearchEngineUrl ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showDeleteGoogleCustomSearchEngineUrlModal" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deleting...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetDeleteModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="deleteGoogleCustomSearchEngineUrlCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <!-- <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Delete Field"
      v-model="showDeleteGoogleCustomSearchEngineUrlModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <p></p>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Google Custom Search Engine Url is being deleting......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Google Custom Search Engine Url has been deleted successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" @click="resetDeleteModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="danger"
          @click="deleteGoogleCustomSearchEngineUrlCall"
        >
          <font-awesome-icon
            v-b-tooltip.hover
            title="Delete Field"
            class="mr-1 text-light"
            icon="trash"
          />Yes
        </b-button>
      </template>
    </b-modal>-->
  </div>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import AppLoader from "../../components/Loader/Loader";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ClientProfileGoogleCustomSearchEngineUrl",
  mixins: [validationMixin],
  components: {
    AppLoader
  },
  data() {
    return {
      form: {
        url: null,
        selectedgoogleCustomSearchEngine: [],
        type: null
      },
      googleCustomSearchEngineUrlId: null,
      showDeleteGoogleCustomSearchEngineUrlModal: false,
      googleCustomSearchEngineOptions: [],
      editGoogleCustomSearchEngineUrl: false,
      isLoading: false,
      showModal: false,
      typeOptions: [
        { text: "Local", value: 1 },
        { text: "Global", value: 2 }
      ],
      tableFields: [
        { key: "created_at", label: "Age", sortable: true },
        {
          key: "google_custom_search_engine_title",
          label: "Title",
          sortable: true
        },
        { key: "url", label: "Url", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "actions", label: "Actions", sortable: false }
      ],
      filter: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      submiting: false,
      responseSuccess: false,
      processing: false,
      counter: 1,
      interval: null
    };
  },
  mounted() {
    this.getGoogleCustomSearchEngineOptions();
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  validations: {
    form: {
      url: { required },
      selectedgoogleCustomSearchEngine: { required },
      type: { required }
    }
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getGoogleCustomSearchEngineUrlTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "post",
        "v1/google-custom-search-engine/get-custom-search-engine-url-list",
        formData,
        {
          Authorization: token
        }
      );

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    async getGoogleCustomSearchEngineOptions() {
      this.googleCustomSearchEngineOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/google-custom-search-engine/get-google-custom-search-engine",
          null,
          {
            Authorization: token
          }
        );
        this.googleCustomSearchEngineOptions =
          result.data.googleCustomSearchEngine;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.form = {
        url: null,
        selectedgoogleCustomSearchEngine: [],
        type: null
      };
      this.$v.form.$reset();
    },
    resetModal() {
      this.resetForm();
      this.editGoogleCustomSearchEngineUrl = false;
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.editGoogleCustomSearchEngineUrl) {
        this.updateGoogleCustomSearchEngineUrl().then(this.reloadTable);
      } else {
        this.saveGoogleCustomSearchEngineUrl().then(this.reloadTable);
      }
    },
    async saveGoogleCustomSearchEngineUrl() {
      let formData = {
        url: this.form.url,
        google_custom_search_engine_ids: this.form
          .selectedgoogleCustomSearchEngine,
        type: this.form.type
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/google-custom-search-engine/create-custom-search-engine-url",
          formData,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        // console.log("------------erroror", err);
      }
    },
    onEditGoogleCustomSearchEngineUrl(data) {
      this.editGoogleCustomSearchEngineUrl = true;
      this.googleCustomSearchEngineUrlId = data.item.id;
      this.form.url = data.item.url;
      this.form.type = data.item.type;
      this.form.selectedgoogleCustomSearchEngine.push(
        data.item.google_custom_search_engine_id
      );
      this.showModal = true;
    },
    async updateGoogleCustomSearchEngineUrl() {
      let formData = {
        google_custom_search_engine_url_id: this.googleCustomSearchEngineUrlId,
        url: this.form.url,
        google_custom_search_engine_ids: this.form
          .selectedgoogleCustomSearchEngine,
        type: this.form.type
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/google-custom-search-engine/update-custom-search-engine-url",
          formData,
          {
            Authorization: token
          }
        );
        this.googleCustomSearchEngineUrlId = null;
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        // console.log("------------erroror", err);
      }
    },
    onDeleteGoogleCustomSearchEngineUrlModal(data) {
      this.googleCustomSearchEngineUrlId = data.item.id;
      this.processing = false;
      this.showDeleteGoogleCustomSearchEngineUrlModal = true;
    },
    deleteGoogleCustomSearchEngineUrlCall() {
      this.counter = 1;
      this.processing = true;
      this.deleteGoogleCustomSearchUrlEngine().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showDeleteGoogleCustomSearchEngineUrlModal = this.processing = false;
          });
        }
      }, 350);
    },
    async deleteGoogleCustomSearchUrlEngine() {
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        let result = await HTTP(
          "get",
          "v1/google-custom-search-engine/deletegooglecustomsearchengineurl/" +
            this.googleCustomSearchEngineUrlId,
          null,
          {
            Authorization: token
          }
        );
        this.googleCustomSearchEngineUrlId = null;
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetDeleteModal() {
      this.showDeleteGoogleCustomSearchEngineUrlModal = false;
    }
  }
};
</script>